import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ActionsPopoverEl } from "common/widgets/actions-popover";
import { SegmentFilterEl } from "common/charts/misc/segment-filter";
import { FunnelsFrequencyDistributionChartWidgetEl } from "common/report/funnels/charts/funnels-frequency-distribution-widget";
import { FunnelsFrequencyLineChartEl } from "common/report/funnels/charts/funnels-frequency-line-chart";
import { FunnelsFrequencyAggregateChartWidgetEl } from "common/report/funnels/charts/funnels-frequency-aggregate-widget";
import { FunnelsTimeToConvertDistributionChartWidgetEl } from "common/report/funnels/charts/funnels-ttc-distribution-widget";
import { FunnelsTTCLineChartEl } from "common/report/funnels/charts/funnels-ttc-line-chart";
import { FunnelsTtcAggregateMetricWidgetEl } from "common/report/funnels/charts/funnels-ttc-aggregate-metric-widget";
import { FunnelsTtcAggregateWidgetEl } from "common/report/funnels/charts/funnels-ttc-aggregate-widget";
import { FunnelsTrendsChartEl } from "common/report/funnels/charts/funnels-trends-chart";
import { FunnelsStepsMetricWidgetEl } from "common/report/funnels/charts/funnels-steps-metric-widget";
import { FunnelsTopPathsChartEl } from "common/report/funnels/charts/funnels-top-path-chart";
import { ChartVizType } from "common/report/constants";
import { getChartWidgetType, hasDataTable, WidgetType } from "common/report/funnels/util";
import { FunnelsStepChartEl } from "common/report/funnels/charts/funnels-step-chart";
import { FunnelStepBookmarkType } from "common/report/funnels/charts/funnels-step-chart/types";
function showLegend(widgetType, isDownloadMode = false) {
  const widgetsWithLegends = [
    WidgetType.TTCAggregateChart,
    WidgetType.TTCDistributionChart,
    WidgetType.FrequencyAggregateChart,
    WidgetType.FrequencyDistributionChart
  ];
  return widgetsWithLegends.includes(widgetType) || !isDownloadMode && [WidgetType.FrequencyLineChart, WidgetType.TTCLineChart].includes(widgetType);
}
function FrequencyPopover({ chartDisplay }) {
  const { frequencySelection } = chartDisplay.state;
  if (!frequencySelection) {
    return null;
  }
  return /* @__PURE__ */ jsx(ActionsPopoverEl, {
    sel: ".frequency",
    attrs: {
      title: chartDisplay.helpers.frequency.popover.popoverTitle(),
      "button-options": chartDisplay.helpers.frequency.popover.buttonOptions(),
      "prevent-close-selectors": [`.bar.hoverable`],
      open: !!frequencySelection
    },
    style: chartDisplay.helpers.frequency.popover.getPopoverPlacement(),
    on: {
      action: chartDisplay.helpers.frequency.popover.handlePopoverAction,
      close: chartDisplay.helpers.frequency.popover.closePopover
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-icon"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".community-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `community` }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text-wrapper"
  }, !chartDisplay.helpers.frequency.isConversionRate() ? chartDisplay.helpers.frequency.popover.popoverBody().map((content) => /* @__PURE__ */ jsx("div", {
    sel: ".popover-slot"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.percent), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.count), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-subtext"
  }, content.subText))) : chartDisplay.helpers.frequency.popover.popoverBodyForConversionRate().map((content) => /* @__PURE__ */ jsx("div", {
    sel: ".popover-slot"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.usersConverted), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.percent), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.usersDroppedOff), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-subtext"
  }, content.subText)))))));
}
function TTCPopover({ chartDisplay }) {
  const { ttcSelection } = chartDisplay.state;
  if (!ttcSelection) {
    return null;
  }
  return /* @__PURE__ */ jsx(ActionsPopoverEl, {
    sel: ".ttc",
    attrs: {
      open: !!ttcSelection,
      title: chartDisplay.helpers.timeToConvert.popover.popoverTitle(),
      "button-options": chartDisplay.helpers.timeToConvert.popover.buttonOptions(),
      "prevent-close-selectors": [`.bar.hoverable`]
    },
    style: chartDisplay.helpers.timeToConvert.popover.getPopoverPlacement(),
    on: {
      action: chartDisplay.helpers.timeToConvert.popover.handlePopoverAction,
      close: chartDisplay.helpers.timeToConvert.popover.closePopover
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-icon"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".community-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `community` }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text-wrapper"
  }, chartDisplay.helpers.timeToConvert.popover.popoverBody().map((content) => /* @__PURE__ */ jsx("div", {
    sel: ".popover-slot"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.percent), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-text"
  }, content.count), /* @__PURE__ */ jsx("div", {
    sel: ".popover-content-subtext"
  }, content.subText)))))));
}
function ChartVisualization({ chartDisplay }) {
  const chartWidgetType = getChartWidgetType(chartDisplay.state.funnelQuery.generateBookmark());
  const vizType = chartDisplay.getChartVizType();
  return /* @__PURE__ */ jsx("div", {
    sel: ".chart-viz-container",
    class: { "resizing-layout": chartDisplay.attr(`resizing-layout`) }
  }, /* @__PURE__ */ jsx(FrequencyPopover, {
    chartDisplay
  }), /* @__PURE__ */ jsx(TTCPopover, {
    chartDisplay
  }), /* @__PURE__ */ jsx("div", {
    sel: ".common-chart-widget-wrapper",
    class: {
      "has-data-table": hasDataTable(chartWidgetType),
      "has-legend": showLegend(chartWidgetType, chartDisplay.helpers.isDownloadMode()),
      "metric-chart": vizType === ChartVizType.Metric,
      "line-chart": vizType === ChartVizType.Line,
      "step-chart": vizType === ChartVizType.Steps,
      "bar-chart": vizType === ChartVizType.Bar,
      "sankey-chart": vizType === ChartVizType.Sankey,
      "is-download-mode": chartDisplay.helpers.isDownloadMode(),
      "resizing-layout": chartDisplay.attr(`resizing-layout`)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".chart-viz"
  }, (() => {
    switch (chartWidgetType) {
      case WidgetType.StepsMetricChart:
        return /* @__PURE__ */ jsx(FunnelsStepsMetricWidgetEl, {
          props: {
            ...chartDisplay.helpers.getDefaultProps(),
            popoverCallback: chartDisplay.helpers.popoverCallback
          },
          on: {
            changeControlGroup: chartDisplay.helpers.changeControlGroup,
            popoverAction: chartDisplay.helpers.steps.handleMetricChartPopoverAction
          }
        });
      case WidgetType.StepChart:
        return /* @__PURE__ */ jsx(FunnelsStepChartEl, {
          sel: ".funnels-step-chart",
          attrs: {
            loaded: true,
            "enable-segment-click": true,
            "min-step-width": 266,
            "max-step-width": 600,
            "resizing-layout": chartDisplay.attr(`resizing-layout`),
            "show-popover": true
          },
          class: {
            "resizing-layout": chartDisplay.attr(`resizing-layout`)
          },
          props: {
            bookmarkData: {
              queryResults: chartDisplay.queryResults,
              bookmark: chartDisplay.state.funnelQuery.generateBookmark(),
              type: FunnelStepBookmarkType.FUNNELS
            },
            selectedSegment: chartDisplay.state.selectedFunnelStepSegment,
            popoverAction: chartDisplay.helpers.popover.handleAction
          },
          on: {
            changeControlGroup: chartDisplay.helpers.changeControlGroup,
            track: chartDisplay.helpers.trackEventFromChild
          }
        });
      case WidgetType.TrendsChart:
        return /* @__PURE__ */ jsx(FunnelsTrendsChartEl, {
          class: {
            "can-use-data-table": true
          },
          attrs: {
            "show-annotations": true
          },
          props: {
            ...chartDisplay.helpers.getDefaultProps(),
            popoverCallback: chartDisplay.helpers.popoverCallback
          },
          on: {
            popoverAction: chartDisplay.helpers.trend.handlePopoverAction
          }
        });
      case WidgetType.TTCAggregateChart:
        return /* @__PURE__ */ jsx(FunnelsTtcAggregateWidgetEl, {
          attrs: chartDisplay.helpers.timeToConvert.getAggregateAttrs(),
          props: chartDisplay.helpers.getDefaultProps()
        });
      case WidgetType.TTCDistributionChart:
        return /* @__PURE__ */ jsx(FunnelsTimeToConvertDistributionChartWidgetEl, {
          attrs: { ...chartDisplay.helpers.timeToConvert.getAggregateAttrs(), "enable-bar-click": true },
          props: chartDisplay.helpers.getDefaultProps(),
          on: {
            openPopover: chartDisplay.helpers.timeToConvert.popover.openPopover
          }
        });
      case WidgetType.TTCLineChart:
        return /* @__PURE__ */ jsx(FunnelsTTCLineChartEl, {
          class: { "is-download-mode": chartDisplay.helpers.isDownloadMode() },
          attrs: { ...chartDisplay.helpers.timeToConvert.getAttrs(), "enable-point-click": true },
          props: chartDisplay.helpers.getDefaultProps(),
          on: {
            openPopover: chartDisplay.helpers.timeToConvert.popover.openPopover
          }
        });
      case WidgetType.TTCMetricChart:
        return /* @__PURE__ */ jsx(FunnelsTtcAggregateMetricWidgetEl, {
          props: chartDisplay.helpers.getDefaultProps()
        });
      case WidgetType.FrequencyAggregateChart:
        return /* @__PURE__ */ jsx(FunnelsFrequencyAggregateChartWidgetEl, {
          attrs: chartDisplay.helpers.frequency.getAggregateAttrs(),
          props: chartDisplay.helpers.getDefaultProps()
        });
      case WidgetType.FrequencyDistributionChart:
        return /* @__PURE__ */ jsx(FunnelsFrequencyDistributionChartWidgetEl, {
          attrs: { ...chartDisplay.helpers.frequency.getAggregateAttrs(), "enable-bar-click": true },
          props: chartDisplay.helpers.getDefaultProps(),
          on: {
            openPopover: chartDisplay.helpers.frequency.popover.openPopover
          }
        });
      case WidgetType.FrequencyLineChart:
        return /* @__PURE__ */ jsx(FunnelsFrequencyLineChartEl, {
          attrs: { ...chartDisplay.helpers.frequency.getAttrs(), "enable-point-click": true },
          props: chartDisplay.helpers.getDefaultProps(),
          on: {
            openPopover: chartDisplay.helpers.frequency.popover.openPopover
          }
        });
      case WidgetType.TopPathsChart:
        return /* @__PURE__ */ jsx("div", {
          sel: ".funnels-top-paths"
        }, /* @__PURE__ */ jsx(FunnelsTopPathsChartEl, {
          props: chartDisplay.helpers.getTopPathsProp()
        }));
    }
  })()), showLegend(chartWidgetType, chartDisplay.helpers.isDownloadMode()) && /* @__PURE__ */ jsx(SegmentFilterEl, {
    sel: ".segment-filter.is-sticky"
  })));
}
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".chart-display",
    class: { "resizing-layout": this.attr(`resizing-layout`) }
  }, /* @__PURE__ */ jsx(ChartVisualization, {
    chartDisplay: this
  }));
}
